<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/usuarios">Corretores</router-link>
          </li>
          <li class="breadcrumb-item active">Criar Corretor</li>
        </ol> 

        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Corretor
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="corretor.email"
                  @blur="setLogin"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="corretor.name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="corretor.last_name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Login</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  readonly
                  v-model="corretor.login"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder
                  v-model="corretor.password"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaCorretor()">Salvar</button>
              </p>
            </div>
          </div>
        </div>
      </div> <!-- /container-fluid-->
    </div> 
    </div> 
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import {Loader, LoaderOptions} from 'google-maps';
import axios from "axios";

export default {
  components: {
    VueEditor,
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      corretor: {
        email: "",
        name: "",
        last_name: "",
        login: "",
        password: "",
      },
      isLoading: false,
    };
  },

  methods: {
    salvaCorretor() {
      let self = this;
      self.isLoading = true;
      ajax("post", "corretores",self.corretor)
        .then(response => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Corretor cadastrado com sucesso!"
          );
          self.$router.replace(this.$route.query.redirect || "/uniodonto/corretores");
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },

    setLogin() {
      this.corretor.login = this.corretor.email;
    }
  },
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map{
  width: 100%;
}

</style>